import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=6118ec04"
import script from "./PopupModal.ts?vue&type=script&lang=ts&external"
export * from "./PopupModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports